import { gql } from "@apollo/client";

export const GET_ACTIVE_SESSION = gql`
  query getActiveSession {
    getActiveSession {
      id
      status
      expert {
        id
        mobileImage: image(size: 120) {
          twox
          threex
        }
        desktopImage: image(size: 120) {
          twox
          threex
        }
        name
        skills {
          badge
        }
        rates {
          chat {
            discounted
            base
          }
          video {
            discounted
            base
          }
        }
        voxImplantInfo {
          userName
        }
      }
      client {
        id
        mobileImage: image(size: 120) {
          twox
          threex
        }
        desktopImage: image(size: 120) {
          twox
          threex
        }
        name
        voxImplantInfo {
          userName
        }
      }
      sessionType
      voxConversationID
    }
  }
`;
